// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/geographical_areas.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/geographical_areas.proto.
 */
export const file_proto_model_core_place_types_geographical_areas = /*@__PURE__*/
  fileDesc("CjVwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2dlb2dyYXBoaWNhbF9hcmVhcy5wcm90bxIGY2FybWVuKoIDChpHZW9ncmFwaGljYWxBcmVhc1BsYWNlVHlwZRItCilHRU9HUkFQSElDQUxfQVJFQVNfUExBQ0VfVFlQRV9VTlNQRUNJRklFRBAAEj0KOUdFT0dSQVBISUNBTF9BUkVBU19QTEFDRV9UWVBFX0FETUlOSVNUUkFUSVZFX0FSRUFfTEVWRUxfMRABEj0KOUdFT0dSQVBISUNBTF9BUkVBU19QTEFDRV9UWVBFX0FETUlOSVNUUkFUSVZFX0FSRUFfTEVWRUxfMhACEikKJUdFT0dSQVBISUNBTF9BUkVBU19QTEFDRV9UWVBFX0NPVU5UUlkQAxIqCiZHRU9HUkFQSElDQUxfQVJFQVNfUExBQ0VfVFlQRV9MT0NBTElUWRAEEi0KKUdFT0dSQVBISUNBTF9BUkVBU19QTEFDRV9UWVBFX1BPU1RBTF9DT0RFEAUSMQotR0VPR1JBUEhJQ0FMX0FSRUFTX1BMQUNFX1RZUEVfU0NIT09MX0RJU1RSSUNUEAZCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.GeographicalAreasPlaceType.
 */
export const GeographicalAreasPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_geographical_areas, 0);

/**
 * Geographical area place types
 *
 * @generated from enum carmen.GeographicalAreasPlaceType
 */
export const GeographicalAreasPlaceType = /*@__PURE__*/
  tsEnum(GeographicalAreasPlaceTypeSchema);

